import React, { useContext } from "react";

import { AuthContext } from "shared/context/auth-context";
import { useTranslation } from "react-i18next";
import { PERMISSION_TYPES } from "shared/util/constants";

// import WalkingDistanceStops from "./WalkingDistanceStops";
import WalkingDistanceCalculator from "./WalkingDistanceCalculator";

import Tabs from "components/shared/Tabs";

const Accounting = () => {
  const { t } = useTranslation();
  const auth = useContext(AuthContext);

  const [tabValue, setTabValue] = React.useState(0);
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (!auth.permissions[PERMISSION_TYPES.ACCESS_TO_WALKING_DISTANCE]) {
    return <div className="center">Yürüyüş mesafesi hesaplama uygulamasına erişiminiz bulunmuyor.</div>;
  }

  let accountingTabs = [];

  // accountingTabs.push({
  //   label: t("Hesaplama"),
  //   content: <WalkingDistanceCalculator />,
  // });

  return (
    <React.Fragment>
      <WalkingDistanceCalculator />
      {/* <Tabs tabs={accountingTabs} tabValue={tabValue} onTabChange={handleTabChange} isVertical={true} /> */}
    </React.Fragment>
  );
};

export default Accounting;
